import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggingPublishersService, LoggingService } from './services';
import { LoggingDatabaseProvider, LoggingDatabaseRepository } from './database';
import { RxdbLogLoggingPublisher } from './publishers/logging-rxdb.publisher';
import { LoggingExportService } from './services/logging-export.service';
import { LoggingHttpService } from './services/logging-http.service';
import { LoggingApiPublisher } from './publishers/logging-api.publisher';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
	declarations: [],
	imports: [CommonModule, HttpClientModule],
	providers: [
		LoggingService,
		LoggingPublishersService,
		LoggingDatabaseProvider,
		LoggingDatabaseRepository,
		RxdbLogLoggingPublisher,
		LoggingExportService,
		LoggingHttpService,
		LoggingApiPublisher
	]
})
export class LoggingModule {}
